<template>
    <div>
        <div>
            <VirtualList
                :data-key="'id'"
                :data-sources="list"
                :data-component="itemComponent"
                :estimate-size="22"
                :keeps="50"
                style="max-height: calc(100vh - 300px);overflow: auto;"
            >
            </VirtualList>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="primary" class="action-btn ml20" plain @click="hideModal">关闭</el-button>
        </p>
    </div>
</template>

<!-- oppo批量 被复制账户&计划详情-->
<script>
import VirtualList from 'vue-virtual-scroll-list'; // 引入虚拟列表组件
import Item from "../components/itemComponent.vue";
export default {
    name: "copyPlanInfoModal",
    props:['cbs', 'list'],
    components: {
        VirtualList
    },
    data(){
        return {
            itemComponent: Item,
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            // this.cbs.onSubmit()
        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style scoped>

</style>
